// extracted by mini-css-extract-plugin
export var avatar = "_rm-3";
export var avatarContainer = "_rm-2";
export var avatarSpacer = "_rm-5";
export var avatarSpacerContainer = "_rm-4";
export var avatarStackContainer = "_rm-1";
export var bubble = "_rm-0";
export var remainderBubble = "_rm-6";